export default [
  {
    icon: 'mdi-information',
    title: 'Lihat Ajuan',
    event: 'onInfoAjuan',
    akses: 'psp-peserta-diklat-guru.batal-ajuan-sekolah',
  },
  {
    icon: 'mdi-send',
    title: 'Ajukan Peserta',
    event: 'onAjuan',
    akses: 'psp-peserta-diklat-guru.ajuan-sekolah',
  },
  {
    icon: 'mdi-close',
    title: 'Batal Ajuan Peserta',
    event: 'onBatalAjuan',
    akses: 'psp-peserta-diklat-guru.batal-ajuan-sekolah',
  },
  {
    icon: 'mdi-account-tie',
    title: 'Pilih Pengawas',
    event: 'onEditPengawas',
    akses: 'psp-peserta-diklat-guru.save-pengawas',
  },
  {
    icon: 'mdi-pencil',
    title: 'Pilih Guru Peserta Diklat',
    event: 'onEditPeserta',
    akses: 'psp-peserta-diklat-guru.save',
  },
  {
    icon: 'mdi-account-remove',
    title: 'Hapus Pengawas',
    event: 'onDeletePengawas',
    akses: 'psp-peserta-diklat-guru.delete-pengawas',
  },
];
